import React from 'react';
import { getGetDocumentCategoriesQueryOptions } from '@area-restrita/api-client/endpoints/document-category/document-category.gen';

import { useQueryTable } from '@/hooks/useQueryTable';

import { columns } from './columns';
import DocumentsCategoriesView from './view';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

const DocumentsCategories: React.FC = () => {
  const { checkAuthorization } = useAuthSessionStore();
  const { query, table } = useQueryTable({
    columns,
    getQueryOptions: getGetDocumentCategoriesQueryOptions,
  });

  const canCreate = checkAuthorization(({ can }) =>
    can('create', 'document_categories'),
  );

  return (
    <DocumentsCategoriesView
      table={table}
      isLoading={query.isLoading}
      canCreate={canCreate}
    />
  );
};

export default DocumentsCategories;
